import { RelatedLinks } from '../models/related-links.interfaces';

export const RelatedLinksMocks: RelatedLinks = {
  links: [
    {
      id: 'knowMedallionStatus',
      label: 'Get to Know Medallion Status',
      url: '/us/en/skymiles/medallion-program/overview',
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/know-medallion-status.svg',
        alt: 'Get to Know Medallion Status'
      }
    },
    {
      id: 'earnSkyMiles',
      label: 'How to Earn SkyMiles',
      url: '/us/en/skymiles/how-to-earn-miles/overview',
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/earn-miles.svg',
        alt: 'How to Earn SkyMiles'
      }
    },
    {
      id: 'useSkyMiles',
      label: 'How to Use SkyMiles',
      url: '/us/en/skymiles/how-to-use-miles/overview',
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/use-miles.svg',
        alt: 'How to Use SkyMiles'
      }
    }
  ],
  disabled: false,
  loaded: true
};

export const RelatedLinksPromotionMocks: RelatedLinks = {
  disabled: false,
  links: [
    {
      id: 'partnerNetwork',
      image: {
        alt: 'Partner Network',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/promotions/related-links/related-partner-network.svg'
      },
      label: 'Partner Network',
      url: '/us/en/skymiles/how-to-earn-miles/skymiles-partners-offers'
    },
    {
      id: 'accountActivity',
      image: {
        alt: 'How to Earn SkyMiles',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/promotions/related-links/related-account-activity.svg'
      },
      label: 'Account Activity',
      url: '/acctactvty/manageacctactvty.action'
    },
    {
      id: 'certsEcreditsVouchers',
      image: {
        alt: 'Certificates, eCredits & Vouchers',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/use-miles.svg'
      },
      label: 'Certificates, eCredits & Vouchers',
      url: '/myprofile/certificates'
    }
  ],
  loaded: true
};
